/* AIVIQ help pages (sections/aiviq-page.liquid): Tryghed, FAQ, Garanti, Brugervejledninger, Reservedele.
   The markup comes from the canvas boards (computer and phone copies side by side: .ad / .am), so every lookup
   by id takes the copy that is shown.
   - Questions with a button (aria-controls): open and close.
   - In-page links: open a closed question on the way, land under the header and the topic bar.
   - Topic bar (Emner / Kategori): sticks under the header and marks the topic in view.
   - Search: filters the questions (FAQ) or the models (Brugervejledninger).
   - »Skriv i chatten«: opens the shop's chat. Links without a target yet are hidden.
   - Reservedele: »Spørg om …« fills in the part; only the shown copy of a field is sent. */
(function () {
  const root = document.querySelector('[data-apg]');
  if (!root || root.dataset.apgReady) return;
  root.dataset.apgReady = '1';
  const page = root.dataset.apg;

  /* 1200–1439 px: the computer layout is drawn for 1440 px and is scaled down to fit (as on the product pages) */
  const fit = () => {
    root.style.removeProperty('--apc-zoom');
    if (!window.matchMedia('(min-width: 1200px) and (max-width: 1439.98px)').matches) return;
    root.style.setProperty('--apc-zoom', (document.documentElement.clientWidth / 1440).toFixed(4));
  };
  fit();
  window.addEventListener('resize', fit);

  const shown = (el) => {
    for (let n = el; n && n !== root; n = n.parentElement) {
      if ((n.classList.contains('ad') || n.classList.contains('am')) && getComputedStyle(n).display === 'none') return false;
    }
    return true;
  };
  const find = (id) => {
    if (!id) return null;
    const all = [...root.querySelectorAll('[id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]')];
    return all.find(shown) || all[0] || null;
  };

  /* links whose target does not exist yet (order tracking, single films, a missing PDF) */
  root.querySelectorAll('a[href="#"]').forEach((a) => {
    const li = a.closest('li');
    if (li && li.querySelectorAll('a').length === 1) li.hidden = true; else a.hidden = true;
  });

  /* questions that open and close */
  const MINUS = 'M5 12h14';
  const PLUS = 'M12 5v14M5 12h14';
  const setOpen = (btn, open) => {
    const panel = find(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    const icons = btn.querySelectorAll('svg');
    const path = icons.length ? icons[icons.length - 1].querySelector('path') : null;
    const d = path ? (path.getAttribute('d') || '').replace(/\s+/g, '') : '';
    if (path && (d === MINUS.replace(/\s+/g, '') || d === PLUS.replace(/\s+/g, ''))) path.setAttribute('d', open ? MINUS : PLUS);
  };
  root.querySelectorAll('button[aria-controls]').forEach((btn) => {
    btn.addEventListener('click', () => setOpen(btn, btn.getAttribute('aria-expanded') !== 'true'));
  });

  /* the header and the topic bar above the reading line */
  const headerOffset = () => {
    const h = document.querySelector('.header-section') || document.querySelector('#SiteHeader');
    if (!h) return 0;
    const pos = getComputedStyle(h).position;
    const r = h.getBoundingClientRect();
    return pos === 'fixed' || pos === 'sticky' || r.top >= 0 ? Math.max(0, r.bottom) : 0;
  };
  const bar = [...root.querySelectorAll('.sd-cbar, .sd-chm, .sd-mfil')].find(shown) || null;
  const barH = () => (bar && getComputedStyle(bar).position === 'sticky' ? bar.offsetHeight : 0);
  const go = (el) => {
    /* a target inside a closed question: open it first */
    for (let n = el; n && n !== root; n = n.parentElement) {
      if (n.hidden && n.id) {
        const btn = [...root.querySelectorAll('button[aria-controls="' + n.id + '"]')].find(shown);
        if (btn) setOpen(btn, true);
      }
    }
    const y = el.getBoundingClientRect().top + window.scrollY - headerOffset() - barH() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
  };
  root.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || !root.contains(a)) return;
    const href = a.getAttribute('href');
    const hash = href.indexOf('#') >= 0 ? decodeURIComponent(href.slice(href.indexOf('#') + 1)) : '';
    if (href.charAt(0) !== '#' && href.charAt(0) !== '?') return;
    e.preventDefault();
    if (href.charAt(0) === '?') pickPart(new URLSearchParams(href.slice(1, href.indexOf('#') >= 0 ? href.indexOf('#') : undefined)).get('del'), a);
    if (hash === 'top' || hash === '') { window.scrollTo({ top: 0, behavior: 'auto' }); return; }
    const target = find(hash);
    if (target) { go(target); try { history.replaceState(null, '', '#' + hash); } catch (x) {} }
  });
  if (location.hash.length > 1) {
    const t = find(decodeURIComponent(location.hash.slice(1)));
    if (t) setTimeout(() => go(t), 60);
  }

  /* the topic bar: under the header, the topic in view is marked */
  if (bar) {
    const links = [...bar.querySelectorAll('a[href^="#"]')]
      .map((a) => ({ a, id: decodeURIComponent(a.getAttribute('href').slice(1)) }))
      .filter((l) => l.id && l.id !== 'top');
    let current = null;
    const update = () => {
      bar.style.top = Math.round(headerOffset()) + 'px';
      const line = headerOffset() + barH() + 40;
      let cur = null;
      links.forEach((l) => { const t = find(l.id); if (t && shown(t) && t.getBoundingClientRect().top <= line) cur = l; });
      if (cur === current) return;
      if (current) current.a.removeAttribute('aria-current');
      if (cur) {
        cur.a.setAttribute('aria-current', 'true');
        const row = cur.a.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: Math.max(0, cur.a.offsetLeft - row.offsetLeft - 16), behavior: 'auto' });
      }
      current = cur;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* search: the questions (FAQ) or the models (Brugervejledninger) */
  const norm = (s) => s.toLowerCase().replace(/\s+/g, ' ').trim();
  root.querySelectorAll('form[role="search"]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    if (!input) return;
    form.addEventListener('submit', (e) => e.preventDefault());
    const items = () => [...root.querySelectorAll(page === 'faq' ? '.sd-qa' : '.sd-mc, .sd-mr')];
    let note = null;
    const run = () => {
      const q = norm(input.value);
      root.querySelectorAll('form[role="search"] input[type="search"]').forEach((o) => { if (o !== input) o.value = input.value; });
      let hits = 0;
      items().forEach((it) => { const ok = !q || norm(it.textContent).indexOf(q) >= 0; it.hidden = !ok; if (ok && shown(it)) hits++; });
      /* a group with nothing left is hidden with its headline */
      root.querySelectorAll(page === 'faq' ? '.tg-s' : '.sd-mg, .sd-ml').forEach((g) => {
        const any = [...g.querySelectorAll(page === 'faq' ? '.sd-qa' : '.sd-mc, .sd-mr')].some((it) => !it.hidden);
        g.hidden = !!q && !any;
        if (page !== 'faq') { const head = g.previousElementSibling; if (head && head.classList.contains('sd-mh')) head.hidden = g.hidden; }
      });
      if (!note) { note = document.createElement('p'); note.className = 'apg-note'; note.setAttribute('role', 'status'); form.insertAdjacentElement('afterend', note); }
      note.hidden = !q;
      note.textContent = !q ? '' : hits ? (hits === 1 ? '1 resultat' : hits + ' resultater') + ' for »' + input.value.trim() + '«' : 'Ingen resultater for »' + input.value.trim() + '«. Skriv til info@aiviq.dk, så hjælper serviceteamet.';
    };
    input.addEventListener('input', run);
  });

  /* »Skriv i chatten«: the shop's chat bubble */
  root.querySelectorAll('[data-chat]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const box = document.getElementById('userlink-chat-bubble-container');
      const el = box && (box.querySelector('button, [role="button"], iframe') || box);
      if (el && el.tagName !== 'IFRAME') el.click();
      else if (box) box.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      else window.location.href = 'mailto:info@aiviq.dk';
    });
  });

  /* »Kom godt i gang« films: a poster opens its film in a player over the page (✕, Esc or a click outside closes) */
  let player = null;
  const closeFilm = () => {
    if (!player) return;
    const v = player.querySelector('video');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    player.remove();
    player = null;
    document.documentElement.classList.remove('apg-film-open');
    if (closeFilm.back) closeFilm.back.focus();
  };
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-film]');
    if (!btn) return;
    closeFilm();
    closeFilm.back = btn;
    player = document.createElement('div');
    player.className = 'apg-film';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Film');
    const x = document.createElement('button');
    x.type = 'button';
    x.className = 'apg-film__x';
    x.setAttribute('aria-label', 'Luk filmen');
    x.textContent = '✕';
    const v = document.createElement('video');
    v.controls = true;
    v.autoplay = true;
    v.playsInline = true;
    v.preload = 'metadata';
    v.src = btn.getAttribute('data-film');
    const poster = btn.querySelector('img');
    if (poster) v.poster = poster.currentSrc || poster.src;
    player.append(x, v);
    player.addEventListener('click', (ev) => { if (ev.target === player || ev.target === x) closeFilm(); });
    document.body.appendChild(player);
    document.documentElement.classList.add('apg-film-open');
    x.focus();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFilm(); });

  /* Reservedele: »Spørg om …« fills in the part */
  function pickPart(slug, link) {
    if (!slug) return;
    const card = link && link.closest('article');
    const name = card && card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : slug.replace(/-/g, ' ');
    root.querySelectorAll('input[name="contact[del]"]').forEach((i) => { i.value = name; });
  }
  if (page === 'reservedele') {
    const del = new URLSearchParams(location.search).get('del');
    if (del) pickPart(del, [...root.querySelectorAll('a[href^="?del="]')].find((a) => a.getAttribute('href').indexOf('?del=' + del + '#') === 0));
    const form = root.querySelector('form');
    if (form) {
      /* photos cannot travel with a shop contact form: the field is hidden and the text says how to send them */
      form.querySelectorAll('[data-apg-foto]').forEach((i) => {
        i.disabled = true;
        let box = i.closest('label');
        while (box && box.parentElement !== form && !box.querySelector('#rf-foto-l')) box = box.parentElement;
        if (box && box !== form) box.hidden = true;
      });
      form.addEventListener('submit', () => {
        /* the computer and the phone layout each hold some fields twice: only the shown copy is sent */
        form.querySelectorAll('input, select, textarea').forEach((f) => { if (f.type !== 'hidden' && !shown(f)) f.disabled = true; });
      });
      if (form.querySelector('.sd-ok, .sd-err')) setTimeout(() => go(form), 80);
    }
  }
})();
